<template>
  <!-- 公司信息 -->
  <div class="gsxx">
    <el-backtop></el-backtop>
    <div class="gsxx_header">
      <img
        style="width: 100%; height: 100%"
        src="../assets/cp/gsjj.png"
        alt=""
      />
    </div>
    <div class="gsjj">
      <div style="
          margin-top: 20px;
          margin-left: 20%;
          color: #d3d3d3;
          cursor: pointer;
        ">
        <span @click="tiaozhuan()">首页></span>
        <span style="color: black">公司简介</span>
      </div>
      <div
        class="bt"
        id="top1"
      >
        <span>公司简介</span>
        <p>COMPANY PROFILE</p>
      </div>
      <div class="content">
        <p style="text-indent: 2em">
          北京蔚来高科技术有限公司，2018年3月成立于北京，多年来公司凭借深厚技术沉淀与持续创新发展，斩获多项自主知识产权成果，构建起完善且成熟的独立研发体系。致力于科技医疗、康养结合、大健康产业领域，着眼于数字化技术服务建设、智慧健康项目开发、科技医疗产品研发；打造医疗健康创新成果转化、医养健康项目咨询设计， 构建智慧健康信息管理软件、AI人工智能慢病管理：病案大数据采集、分析、AI智能学习系统、AI运动识别系统、AI图像识别系统、健康科普专栏系统、健康医疗专项培训系统等诸多项目开发的高新技术企业。
        </p>
      </div>
      <div class="card">
        <div
          class="jtcard"
          v-for="item in jjData"
        >
          <h3>
            <span style="font-size: 50px; padding: 10px">{{ item.num }}</span>{{ item.dw }}
          </h3>
          <p>{{ item.bt }}</p>
          <p>{{ item.btfy }}</p>
          <div
            v-if="item.btfy == 'Integrated circuit layout'"
            style="
              margin: 10px;
              margin-left: 80px;
              padding: 10px 30px;
              width: 200px;
              border-left: 1px dotted #000;
              border-bottom: 1px dotted #000;
              border-right: 1px dotted #000;
            "
          ></div>
          <div
            v-if="item.btfy == 'Utility model'"
            style="
              margin: 10px;
              margin-left: 100px;
              padding: 10px 30px;
              width: 180px;
              border-right: 1px dotted #000;
              border-bottom: 1px dotted #000;
            "
          ></div>
          <div
            v-if="item.btfy == 'Appearance design'"
            style="
              margin: 10px;
              margin-left: 100px;
              padding: 10px 30px;
              width: 180px;
              border-right: 1px dotted #000;
              border-bottom: 1px dotted #000;
            "
          ></div>
          <div
            style="margin-left: 140px;width: 180px;"
            v-if="item.btfy == 'Utility model'"
          >知识产权</div>
        </div>
      </div>
    </div>
    <div
      class="gsgc wow fadeInUp"
      data-wow-duration=".5s"
      id="top2"
    >
      <div class="bt">
        <span>组织结构</span>
        <p>ORGANIZATION STRUCTURE</p>
      </div>

      <div class="card">
        <img
          height="500px"
          src="../assets/zzjg.png"
          alt=""
        />
        <!-- <div
          class="jtcard"
          :style="item.id == 1 || item.id == 3 ? 'height:410px ' : ''"
          v-for="item in GCData"
        >
          <img
            :style="
              item.id == 1 || item.id == 3
                ? 'width: 281px; '
                : 'height: 299px;width: 281px;'
            "
            :src="item.path"
            alt=""
          />
          <h3>
            <span style="font-size: 24px; padding-right: 10px">{{
              item.num
            }}</span
            >{{ item.dw }}
          </h3>
          <p>{{ item.bt }}</p>
        </div> -->
      </div>
    </div>
    <div
      class="ywfw wow fadeInUp"
      data-wow-duration=".5s"
    >
      <div class="bt">
        <span>业务范围</span>
        <p>SCOPE OF BUSINESS</p>
      </div>
      <div class="card">
        <div
          class="jtcard"
          @mouseover="changeIndex('1')"
          @mouseout="changeIndexBack('1')"
        >
          <img
            v-show="!show1"
            src="../assets/gy/二级-虚拟资源.png"
          />
          <img
            v-show="show1"
            src="../assets/gy/二级-虚拟资源 拷贝.png"
          />
          <h3>01</h3>
          <p>教育培训医工结合项目<br />研发及技术服务</p>
          <div class="link">
            <div class="linkxz"></div>
          </div>
        </div>
        <div
          class="jtcard"
          @mouseover="changeIndex('2')"
          @mouseout="changeIndexBack('2')"
        >
          <img
            v-show="!show2"
            src="../assets/gy/女人.png"
          />
          <img
            v-show="show2"
            src="../assets/gy/女人 拷贝.png"
          />
          <h3>02</h3>
          <p>“中医数字人”数据平台<br />建设及服务</p>
          <div class="link">
            <div class="linkxz"></div>
          </div>
        </div>
        <div
          class="jtcard"
          @mouseover="changeIndex('3')"
          @mouseout="changeIndexBack('3')"
        >
          <img
            v-show="!show3"
            src="../assets/gy/vr.png"
          />
          <img
            v-show="show3"
            src="../assets/gy/vr 拷贝.png"
          />
          <h3>03</h3>
          <p>智慧健康产品<br />设计研发</p>
          <div class="link">
            <div class="linkxz"></div>
          </div>
        </div>
        <div
          class="jtcard"
          @mouseover="changeIndex('4')"
          @mouseout="changeIndexBack('4')"
        >
          <img
            v-show="!show4"
            src="../assets/gy/大数据.png"
          />
          <img
            v-show="show4"
            src="../assets/gy/大数据 拷贝.png"
          />
          <h3>04</h3>
          <p>技能实训仿真平台<br />建设及服务</p>
          <div class="link">
            <div class="linkxz"></div>
          </div>
        </div>
      </div>
      <div class="bt">
        <span>知识产权</span>
        <p>INTELLECTUAL PROPERTY</p>
      </div>
      <div class="card">
        <el-popover
          placement="bottom"
          width="550"
          trigger="click"
        >
          <el-table
            :data="gridData"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column
              width="100"
              property="lx"
              label="类型"
            ></el-table-column>
            <el-table-column
              width="250"
              property="zlmc"
              label="名称"
            ></el-table-column>
            <el-table-column
              width="200"
              property="zlh"
              label="登记证书号"
            ></el-table-column>
          </el-table>
          <div
            slot="reference"
            class="jtcard"
          >
            <img src="../assets/zscq/X1项.png" />
            <p style="margin-top: 20px">集成电路布图设计</p>
          </div>
        </el-popover>
        <el-popover
          placement="bottom"
          width="550"
          trigger="click"
        >
          <el-table
            :data="gridData1"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column
              width="100"
              property="lx"
              label="类型"
            ></el-table-column>
            <el-table-column
              width="250"
              property="zlmc"
              label="专利名称"
            ></el-table-column>
            <el-table-column
              width="200"
              property="zlh"
              label="专利号"
            ></el-table-column>
          </el-table>
          <div
            slot="reference"
            class="jtcard"
          >
            <img src="../assets/zscq/专利.png" />
            <p style="margin-top: 20px">实用新型专利</p>
          </div>
        </el-popover>
        <el-popover
          placement="bottom"
          width="550"
          trigger="click"
        >
          <el-table
            :data="gridData0"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column
              width="100"
              property="lx"
              label="类型"
            ></el-table-column>
            <el-table-column
              width="250"
              property="zlmc"
              label="专利名称"
            ></el-table-column>
            <el-table-column
              width="200"
              property="zlh"
              label="专利号"
            ></el-table-column>
          </el-table>
          <div
            slot="reference"
            class="jtcard"
          >
            <img src="../assets/zscq/wgsj.png" />
            <p style="margin-top: 20px">外观设计专利</p>
          </div>
        </el-popover>
        <el-popover
          placement="bottom"
          width="580"
          trigger="click"
        >
          <el-table
            :data="gridData2"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
            height="500px"
          >
            <el-table-column
              width="100"
              property="lx"
              label="类型"
            ></el-table-column>
            <el-table-column
              width="280"
              property="zlmc"
              label="软件名称"
            ></el-table-column>
            <el-table-column
              width="200"
              property="zlh"
              label="登记号"
            ></el-table-column>
          </el-table>
          <div
            slot="reference"
            class="jtcard"
          >
            <img src="../assets/zscq/X16项.png" />
            <p style="margin-top: 20px">软件著作权</p>
          </div>
        </el-popover>

        <!-- <div class="jtcard">
          <img src="../assets/zscq//X3项.png" />
          <p style="margin-top: 20px">注册商标</p>
        </div> -->
      </div>
      <!-- <div class="bt">
        <span>专家顾问</span>
        <p>EXPERT CONSULTANT</p>
      </div> -->
      <!-- <div class="zjgw" v-for="item in zjData">
        <div class="tx">
          <img
            style="width: 100%; height: 100%"
            :src="$store.state.httpsURL + item.picture"
            alt=""
          />
          <p style="font-size: 20px">{{ item.title }}</p>
        </div>
        <div>
          <p style="font-size: 18px; font-weight: 600">个人履历</p>
          <div class="content" v-html="item.detail"> -->
      <!-- {{item}} -->
      <!-- </div>
        </div>
      </div> -->
      <Contact></Contact>
    </div>
  </div>
</template>
<script>
import WOW from "wowjs";
import Contact from "../components/ContactUs.vue";
import { selectbrief } from "@/api/patient.js";
export default {
  components: { Contact },
  name: "Home",
  data() {
    return {
      form: {
        name: "",
        region: "",
        desc: "",
      },
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      gridData: [
        {
          lx: "集成电路布图设计",
          zlmc: "薄膜压力矩阵传感器微控制芯片",
          zlh: "第51217号",
        },
      ],
      gridData0: [
        {
          lx: "外观设计",
          zlmc: "推拿实训教考仪",
          zlh: "ZL 2024 3 0223516.7",
        },
      ],
      gridData1: [
        {
          lx: "实用新型",
          zlmc: "一种背部针刺技能实训仿真系统",
          zlh: "ZL202021568939.5",
        },
        // {
        //   lx: "实用新型",
        //   zlmc: "智能精准中医技能培训考核系统",
        //   zlh: "ZL201721153408.8",
        // },
        {
          lx: "实用新型",
          zlmc: "一种中医技能考核头戴式显控设备",
          zlh: "ZL202120160741.1",
        },
      ],
      gridData2: [
        {
          lx: "软件著作权",
          zlmc: "静脉输液与输血虚拟仿真实训系统",
          zlh: "2021SR1187507",
        },
        {
          lx: "软件著作权",
          zlmc: "傣医药概论虚拟仿真实训系统",
          zlh: "2021SR1190409",
        },
        {
          lx: "软件著作权",
          zlmc: "中医诊断技能实训仿真系统",
          zlh: "2021SR1187542",
        },
        {
          lx: "软件著作权",
          zlmc: "智能精准中医技能实训仿真平台",
          zlh: "2021SR1190064",
        },
        {
          lx: "软件著作权",
          zlmc: "虚拟仿真教学平台软件(客户端)",
          zlh: "2021SR1187656",
        },
        {
          lx: "软件著作权",
          zlmc: "虚拟仿真教学平台软件(服务器)",
          zlh: "2021SR1190146",
        },
        {
          lx: "软件著作权",
          zlmc: "正常人体解剖技能教学软件(标准版)",
          zlh: "2021SR1190016",
        },
        {
          lx: "软件著作权",
          zlmc: "中医针刺技能实训仿真系统",
          zlh: "2021SR1181742",
        },
        {
          lx: "软件著作权",
          zlmc: "中医推拿技能实训仿真系统",
          zlh: "2021SR1190069",
        },
        {
          lx: "软件著作权",
          zlmc: "中医技能手法腰背部训练系统",
          zlh: "2021SR1183238",
        },
        {
          lx: "软件著作权",
          zlmc: "推拿手法数据采集分析系统",
          zlh: "2021SR1187594",
        },
        {
          lx: "软件著作权",
          zlmc: "中医技能手法实训仿真系统",
          zlh: "2021SR1190247",
        },
        {
          lx: "软件著作权",
          zlmc: "针刺训练统计分析系统",
          zlh: "2021SR1190015",
        },
        {
          lx: "软件著作权",
          zlmc: "中医经络腧穴实训仿真系统",
          zlh: "2021SR1191583",
        },
        {
          lx: "软件著作权",
          zlmc: "中医舌诊技能实训仿真系统(学生端)",
          zlh: "2021SR1181738",
        },
        {
          lx: "软件著作权",
          zlmc: "中医舌诊技能实训仿真系统(教师端)",
          zlh: "2021SR1181739",
        },
        {
          lx: "软件著作权",
          zlmc: "中医经络腧穴综合考核测评系统",
          zlh: "2022SR0251316",
        },
        {
          lx: "软件著作权",
          zlmc: "中医推拿仿真实操训练软件",
          zlh: "2022SR0405769",
        },
        {
          lx: "软件著作权",
          zlmc: "中医望诊仿真实操训练软件",
          zlh: "2022SR0405756",
        },
        {
          lx: "软件著作权",
          zlmc: "中医脉诊仿真实操训练软件",
          zlh: "2022SR0409450",
        },
        {
          lx: "软件著作权",
          zlmc: "骨骼肌肉触诊仿真实操训练软件",
          zlh: "2022SR0409444",
        },
        {
          lx: "软件著作权",
          zlmc: "中医针刺仿真实操训练软件",
          zlh: "2022SR0447214",
        },
        {
          lx: "软件著作权",
          zlmc: "中医针刺手法质量评测软件",
          zlh: "2022SR0405768",
        },
        {
          lx: "软件著作权",
          zlmc: "中医问诊仿真实操训练软件",
          zlh: "2022SR0409445",
        },
        {
          lx: "软件著作权",
          zlmc: "V医公益捐助平台软件(用户端)",
          zlh: "2025SR1391323",
        },
        {
          lx: "软件著作权",
          zlmc: "V医健康评估软件(用户端)",
          zlh: "2025SR1391322",
        },
        {
          lx: "软件著作权",
          zlmc: "V医居家服务管理软件(用户端)",
          zlh: "2025SR1391324",
        },
        {
          lx: "软件著作权",
          zlmc: "V医慢病管理软件(用户端)",
          zlh: "2025SR1361676",
        },
        {
          lx: "软件著作权",
          zlmc: "V医中医背部经络基础信息学习系统",
          zlh: "2025SR1361648",
        },
        {
          lx: "软件著作权",
          zlmc: "V医健康挂号服务软件(用户端)",
          zlh: "2025SR1367644",
        },
        {
          lx: "软件著作权",
          zlmc: "V医健康商城管理软件(用户端)",
          zlh: "2025SR1367598",
        },
        {
          lx: "软件著作权",
          zlmc: "V医健康数据采集软件(用户端)",
          zlh: "2025SR1367611",
        },
        {
          lx: "软件著作权",
          zlmc: "V医未病管理软件(用户端)",
          zlh: "2025SR1367659",
        },
        {
          lx: "软件著作权",
          zlmc: "V医中医背部穴位位置练习实训仿真系统",
          zlh: "2025SR1352830",
        },
        {
          lx: "软件著作权",
          zlmc: "V医健康档案管理软件(用户端)",
          zlh: "2025SR1352666",
        },
        {
          lx: "软件著作权",
          zlmc: "健康管理平台软件系统(中心管理端)",
          zlh: "2025SR1352659",
        },
        {
          lx: "软件著作权",
          zlmc: "V医健康问诊医疗服务软件(用户端)",
          zlh: "2025SR1352685",
        },
      ],
      GCData: [
        {
          id: 1,
          num: "靳松",
          dw: "总经理",
          bt: "北京蔚来高科技术有限公司总经理",
          path: require("../assets/gy/avatar.png"),
        },
        {
          id: 2,
          num: "王总",
          dw: "董事长",
          bt: "北京蔚来高科技术有限公司董事长",
          path: require("../assets/gy/avatar.png"),
        },
        {
          id: 3,
          num: "卫飞",
          dw: "财务总监",
          bt: "北京蔚来高科技术有限公司财务总监",
          path: require("../assets/gy/avatar.png"),
        },
      ],
      jjData: [
        {
          id: 1,
          num: 10,
          dw: "家",
          bt: "合作单位",
          btfy: "Cooperative university",
        },
        {
          id: 2,
          num: 7,
          dw: "年",
          bt: "行业沉淀",
          btfy: "Industry precipitation",
        },
        {
          id: 3,
          num: 1,
          dw: "项",
          bt: "集成电路布图设计",
          btfy: "Integrated circuit layout",
        },
        {
          id: 4,
          num: 2,
          dw: "项",
          bt: "实用新型",
          btfy: "Utility model",
        },
        {
          id: 5,
          num: 1,
          dw: "项",
          bt: "外观设计",
          btfy: "Appearance design",
        },
        {
          id: 6,
          num: "30+",
          dw: "项",
          bt: "软件著作权",
          btfy: "Software copyright",
        },
      ],
      zjData: [],
    };
  },

  mounted() {
    this.$router.afterEach((to, from, next) => {
      if (to.params.lx == "公司简介") {
        setTimeout(() => {
          const TOP = document.getElementById("top1");
          const y = TOP.offsetTop;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }, 1000);
      } else if (to.params.lx == "主要领导介绍") {
        setTimeout(() => {
          const TOP = document.getElementById("top2");
          const y = TOP.offsetTop;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }, 1000);
      }
      // else if (to.params.lx == "专家顾问") {
      //   setTimeout(() => {
      //     window.scrollTo({
      //       top: 2200,
      //       behavior: "smooth",
      //     });
      //   }, 500);
      // }
    });
    this.getSelectbrief();
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: false,
        live: true,
      });
      wow.init();
    }, 200);
  },

  methods: {
    //获取专家
    getSelectbrief() {
      let data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      data.append("dentity", "专家顾问");
      selectbrief(data).then((res) => {
        this.zjData = res.rows;
      });
    },
    changeIndex(e) {
      // 鼠标移入事件
      switch (e) {
        case "1":
          this.show1 = true;
          break;
        case "2":
          this.show2 = true;
          break;
        case "3":
          this.show3 = true;
          break;
        case "4":
          this.show4 = true;
          break;
      }
    },
    changeIndexBack(e) {
      // 鼠标移出事件
      switch (e) {
        case "1":
          this.show1 = false;
          break;
        case "2":
          this.show2 = false;
          break;
        case "3":
          this.show3 = false;
          break;
        case "4":
          this.show4 = false;
          break;
      }
    },
    tiaozhuan() {
      this.$router.push("/");
    },
  },

  watch: {
    "$store.state.rutset": {
      deep: true, //深度监听设置为 true
      handler: function (newVal, oldVal) {
        if (newVal == "公司简介") {
          setTimeout(() => {
            const TOP = document.getElementById("top1");
            const y = TOP.offsetTop;
            window.scrollTo({
              top: y,
              behavior: "smooth",
            });
          });
        } else if (newVal == "主要领导介绍") {
          setTimeout(() => {
            const TOP = document.getElementById("top2");
            const y = TOP.offsetTop;
            window.scrollTo({
              top: y,
              behavior: "smooth",
            });
          });
        }
        // else if (newVal == "专家顾问") {
        //   window.scrollTo({
        //     top: 2200,
        //     behavior: "smooth",
        //   });
        // }
      },
    },
  },
};
</script>
<style scoped>
>>> .el-input__inner {
  height: 60px;
}
</style>
<style lang="scss" scoped>
.gsxx {
  width: 100%;

  .ywfw {
    width: 100%;

    .card {
      display: flex;
      justify-content: center;
      align-items: center;

      .jtcard:hover {
        text-align: center;
        cursor: pointer;
        width: 265px;
        // height: 424px;
        background: #ffffff;
        margin: 20px;
        border-radius: 10px;

        // box-shadow: 0px 0px 10px 0px rgba(170,175,175,0.21);
        .link {
          margin: auto;
          width: 104px;
          height: 1px;
          border: solid 1px #317df6;
          text-align: center;

          .linkxz {
            width: 32px;
            height: 3px;
            margin: auto;
            background: #317df6;
          }
        }

        h3 {
          margin-top: 1px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #317df6;
        }

        p {
          margin-top: -10px;
          width: 265px;
          height: 61px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #317df6;
        }
      }

      .jtcard {
        text-align: center;
        width: 265px;
        cursor: pointer;
        // height: 424px;
        background: #ffffff;
        margin: 20px;
        border-radius: 10px;

        // box-shadow: 0px 0px 10px 0px rgba(170,175,175,0.21);
        .link {
          margin: auto;
          width: 104px;
          height: 1px;
          border: solid 1px #404040;
        }

        h3 {
          margin-top: 1px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #171717;
        }

        p {
          margin-top: -10px;
          width: 265px;
          height: 61px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
        }
      }
    }

    .bt {
      padding-top: 70px;
      text-align: center;

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }

    .zjgw {
      width: 1160px;
      height: 279px;
      margin: auto;
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      background: #ffffff;
      border-radius: 10px;

      // box-shadow: 0px 0px 10px 0px rgba(145, 151, 151, 0.21);
      .tx {
        width: 213px;
        height: 279px;
        text-align: center;
      }

      .content {
        width: 921px;
        height: 260px;
        text-align: left;
        // font-size: 12px;
        // font-family: Microsoft YaHei;
        // font-weight: bold;
        // color: #333333;
        line-height: 16px;
      }
    }
  }

  .gsgc {
    height: 42.5rem;
    // opacity: 0.4;
    background: #0044ce;
    background-image: url(../assets/gy/9436aea7046b33186f82c55968d8659.png);
    background-size: 100%, 100%;
    background-size: cover;
    background-repeat: no-repeat;

    .card {
      display: flex;
      justify-content: center;
      align-items: center;

      .jtcard {
        width: 281px;
        height: 424px;
        background: #ffffff;
        margin-top: 30px !important;
        margin: 50px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px 0px rgba(170, 175, 175, 0.21);

        h3 {
          margin-left: 20px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #171717;
        }

        p {
          margin-top: -10px;
          margin-left: 20px;
          margin-right: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #676767;
        }
      }
    }

    .bt {
      padding-top: 70px;
      text-align: center;

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  .gsxx_header {
    width: 100%;
    height: 407px;
    // background-image: url(../assets/gy/cd2522fe6c8b4a866dc3f254fe557baf.png);
    // background-size: 100%, 100%;
    // background-size: contain;
    // background-repeat: no-repeat;
  }

  .content {
    margin: auto;
    width: 1006px;
    // height: 55px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #656565;
    text-align: left;
  }

  .gsjj {
    width: 100%;
    // height: 550px;

    .card {
      display: flex;
      justify-content: center;
      align-items: center;

      .jtcard {
        width: 200px;
        height: 250px;
        margin: 20px;
        border-radius: 10px;
        // box-shadow: 0px 0px 10px 0px rgba(170,175,175,0.21);
        text-align: center;

        h3 {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #171717;
        }

        p {
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #676767;
        }
      }
    }

    .bt {
      padding-top: 70px;
      text-align: center;

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
</style>
